<div class="container">
    <form [formGroup]="form" (submit)="submit()">
        <mat-card>
            <mat-card-content>
                <div class="row">
                    <mat-form-field appearance="outline">
                        <mat-label>Senha</mat-label>
                        <input matInput type="password" formControlName="password" />
                    </mat-form-field>
                </div>
            </mat-card-content>
            <mat-card-actions>
                <button mat-raised-button color="primary" type="submit">Continuar</button>
            </mat-card-actions>
        </mat-card>
    </form>
</div>